/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PublishsetTagResponse } from '../types/PublishsetTag';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PublishsetTagsRetrieveRequest = {} | null | undefined;
export type PublishsetTagsRetrieveResponse = PublishsetTagResponse;

export type PublishsetTagsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this publishset tag.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/publishset_tags/{id}/
 *
 * ```yaml
 * operationId: publishset_tags_retrieve
 * tags:
 *   - publishset_tags
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetTag'
 *     description: ''
 * ```
 */
export const publishsetTagsRetrieveOperation = ({ id, ...rest }: PublishsetTagsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/publishset_tags/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/publishset_tags/{id}/' };
  };

/**
 * GET /dmx-server/publishset_tags/{id}/
 *
 * ```yaml
 * operationId: publishset_tags_retrieve
 * tags:
 *   - publishset_tags
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetTag'
 *     description: ''
 * ```
 */
export const publishsetTagsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PublishsetTagsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PublishsetTagResponse>> => {
  const operation = publishsetTagsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/publishset_tags/{id}/
 */
export const usePublishsetTagsRetrieveResource = (
  query: PublishsetTagsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<PublishsetTagsRetrieveResponse> => {
  return useResource<PublishsetTagsRetrieveResponse>({
    path: query === null ? null : publishsetTagsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
